import { DatePipe } from '@angular/common';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, ElementRef, HostListener, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { DragAndDropEventArgs, TreeViewComponent } from '@syncfusion/ej2-angular-navigations';
import {
  View, GroupModel, TimeScaleModel, PopupOpenEventArgs,
  WorkHoursModel, ResourceDetails, ScheduleComponent, ActionEventArgs, CellClickEventArgs,
  DragEventArgs, PopupCloseEventArgs
} from '@syncfusion/ej2-angular-schedule';
import { EventSettingsModel } from '@syncfusion/ej2-angular-schedule';

import { closest, addClass, } from '@syncfusion/ej2-base';
import { IMyDateModel, IMyDpOptions } from 'mydatepicker';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DateService } from 'src/app/date.service';
import { GlobalComponent } from 'src/app/global/global.component';
import { updatecalendarschedule, UpdateNonscheduleBO } from './calendar-schedule.model';
import { CommonApiService } from 'src/app/commonapiservice';
import { agencyStatusList } from '../agency/agency.model';
import { GetcalendarBO  } from './calendar-schedule.model';
@Component({
  selector: 'app-calendar-schedule',
  templateUrl: './calendar-schedule.component.html',
  styleUrls: ['./calendar-schedule.component.scss']
})
export class CalendarScheduleComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  Color = '#ff6600';
  wordColor = '#ffffff';
  EmployeeList: any;
  endHour = "23:30";
  ClientId: any;
  argSt: any;
  EmployeeId: any;
  argEnd: any;
  @ViewChild('scheduleObj')
  public scheduleObj: ScheduleComponent;
  @ViewChild('treeObj')
  public treeObj: TreeViewComponent;
  @ViewChild('calenderFilter') calenderFilterHeight: ElementRef;
  bool = false;
  popupdata: any = [];
  empname: string;
  NewEmployeeId: string;
  oldStatus: any;
  saveEditErr: boolean = false;
  statusvalue: any = "";
  nonscheduled: { [key: string]: Object }[];
  scheduledList: any = [];
  public selectedDate: Date = new Date();
  calendarDate: any = new Date();
  public currentView: View = 'TimelineDay';
  public workHours: WorkHoursModel = { start: '06:00', end: '18:00' };
  public timefrom: any = "";
  refresh: Subject<any> = new Subject();
  @ViewChild('tripFilters') tripFiltersHeight: ElementRef;
  updateData: any = [];
  updateNonScheduleBO: UpdateNonscheduleBO = new UpdateNonscheduleBO();
  public allowDragAndDrop: boolean = true;
  public field: any;
  public eventSettings: EventSettingsModel = {
    dataSource: [{ isReadOnly: true }],
    fields: {
      subject: { title: 'Name', name: 'Name' },
      startTime: { title: 'startTime', name: 'startTime' },
      endTime: { title: 'endTime', name: 'endTime' },
      description: { title: 'Reason', name: 'Description' }
    }
  };
  schedulestatus: any = [];
  saveAuthErr: string = '';
  saveErr: string = "";
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'mm/dd/yyyy',
    showClearDateBtn: false,
    editableDateField: true
  };
  scheduleEditList: any = [];
  FrequencyForm: FormGroup;
  public draggedItemId: string = '';
  ClientList: any;
  public isTreeItemDropped: boolean = false;
  public group: GroupModel = { enableCompactView: false, resources: ['Employees'] };
  public timeScale: TimeScaleModel = {
    enable: true,
    interval: 30,
    slotCount: 2,
  };
  isClickButton: boolean = false;
  updatecalendarschedule: updatecalendarschedule = new updatecalendarschedule();
  CustomFrequencyList: agencyStatusList[];
  customFrequencyLid: any;
  oldscheduleEmployeeId: any;
  events: any[] = [];  // Full employee list
  paginatedEmployees: any[] = [];  // Employees shown on the current page
  pageSize: number = 100;  // Default page size
  currentPage: number = 1;
  totalEmployees: number = 0;
  totalPages: number = 1;
  stoppagination:boolean=false;
  isTimeChange: boolean = false;
  startHour: any;
  newDate: any;
  getEvent : GetcalendarBO = new GetcalendarBO();
isEvents:boolean=false;  clientConfirmation: boolean;
  getConfirmation: boolean;
  StartDate: string | number | Date;
  EndDate: string | number | Date;
  msg: string;
  
  constructor(public CommonAPI: CommonApiService,
    public dateservice: DateService, private ref: ChangeDetectorRef, public toastrService: ToastrService, public http: HttpClient, public datepipe: DatePipe, private formBuilder: FormBuilder, public global: GlobalComponent, public router: Router) {
    this.global.agencyList();
    this.field = { dataSource: this.nonscheduled, id: 'Id', text: 'Name' };
    this.FrequencyForm = this.formBuilder.group({
      StartTime: [""],
      EndTime: [""],
      Employee: [""],
      ScheduledDate: [""],
      ScheduleStatus: [""],
    });
  }
  ngOnInit(): void {
    this.getEmployeeType()
    if (this.global.globalAgencyId == null || this.global.globalAgencyId == '' || this.global.globalAgencyId == undefined || this.global.globalAgencyId == '00000000-0000-0000-0000-000000000000') {
      return;
    }
    this.calendarDate = (new Date().getMonth() + 1) + '/' + new Date().getDate() + '/' + new Date().getFullYear();
    this.nonscheduled = [];
    this.timefrom = this.datepipe.transform(this.newDate, "yyyy-MM-dd HH:mm:ss");
    let time = this.datepipe.transform(new Date(), "HH:mm");
    let date = new Date();
    let cureentDay = this.datepipe.transform(date, "MM/dd/yyyy");


    if (
      this.calendarDate != "" &&
      this.calendarDate != null &&
      this.calendarDate != undefined
    ) {
      this.calendarDate = this.calendarDate;
    } else {
      this.calendarDate = cureentDay;
    }
    const time1 = time.split(":")[0];
    const time2 = time.split(":")[1];
    let editTime = +time2;
    if (editTime < 30) {
      this.timefrom = time1 + ":00";
      time = time1 + ":00";
    } else {
      this.timefrom = time1 + ":30";
      time = time1 + ":30";
    }
    this.isTimeChange = true;

    let d = new Date().toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
    let cureent = parseInt(d) - 1;
    this.startHour = cureent.toString();
    if (this.isTimeChange) {
      this.setWorkHours();
      this.isTimeChange = false;
    }
    // -----------------------------------------------for refresh-------------------
    // this.router.routeReuseStrategy.shouldReuseRoute = function () {d
    //   return false;
    // };
    var now = new Date();
    var globalDate = new Date(this.calendarDate);
    if (
      globalDate.getDate() === now.getDate() &&
      globalDate.getMonth() === now.getMonth() &&
      globalDate.getFullYear() === now.getFullYear()
    ) {
    } else {
      this.timefrom =
        this.global.timefrom != "" &&
          this.global.timefrom != null &&
          this.global.timefrom != " "
          ? this.global.timefrom
          : this.timefrom;
    }
    this.getData();
    this.getCalendarScheduledLists();
    this.getCustomFrequency();
    this.eventSettings.dataSource = this.nonscheduled;
    this.eventSettings.editFollowingEvents = true;
  }
//////////////////  Set Height ////////////////////////////////
schduleheight = {
  calendarHeight: '600px' // Default height
};
ngAfterViewInit() {
  this.updateScheduleHeight();
}

@HostListener('window:resize')
@HostListener('window:zoom')
updateScheduleHeight() {
  const zoomLevel = window.devicePixelRatio; // Detect zoom level
  const windowHeight = window.innerHeight;

  let adjustedHeight;

  if (zoomLevel === 1) {
    adjustedHeight = 480; // Set height to 480px when zoom is 100%
  } else {
    adjustedHeight = Math.max(360, (windowHeight * 0.75) / zoomLevel);
  }

  this.global.calendarHeight = `${adjustedHeight}px`;

  if (this.scheduleObj) {
    this.scheduleObj.height = this.global.calendarHeight;
    this.scheduleObj.dataBind(); // Re-render the schedule
  }
}

 ///////////////////////////////////////////////get employee  dropdown//////////////////////////////////////////////////////
 getEmployeeType() {
  let inactiveEmployee = false;
  let url = "api/Event/GetEventUserDropDown?";
  this.http.get(url).pipe().subscribe((data : any) =>{
    this.EmployeeList = data;
  })
 
}
  getConsultantName(value: ResourceDetails): string {
    return (value as ResourceDetails).resourceData[(value as ResourceDetails).resource.textField] as string;
  }
  getData() {
    if (this.isTimeChange) {
      this.setWorkHours();
    }
    this.getEmployee();
  }
  onDateChanged(event: IMyDateModel) {
    this.calendarDate = event.formatted;
    if (event.formatted == null || event.formatted == undefined || event.formatted == '') {
      this.selectedDate = new Date();
    }
    else {
      this.selectedDate = new Date(event.formatted);
    }
    this.getCalendarScheduledLists();
  }
  newdates(event, type, name) {
    if (type == "inputchage") {
      let val = this.dateservice.inputFeildchange(event);
      if (val != undefined) {
        let val1 = this.dateservice.inputFeildchange(event);
        if (name == "startDate") {
          this.scheduleEditList.startDate = val1;
        }
      }
    }
    if (type == "datechagned") {
      let val = this.dateservice.Datechange(event);
      if (val != undefined) {
        let val1 = this.dateservice.Datechange(event);
        if (name == "startDate") {
          this.scheduleEditList.startDate = val1;
        }
      }
    }
  }
  onItemDrag(event: any): void {
    if (this.scheduleObj.isAdaptive) {
      let classElement: HTMLElement = this.scheduleObj.element.querySelector('.e-device-hover');
      if (classElement) {
        classElement.classList.remove('e-device-hover');
      }
      if (event.target.classList.contains('e-work-cells')) {
        addClass([event.target], 'e-device-hover');
      }
    }
    if (document.body.style.cursor === 'not-allowed') {
      document.body.style.cursor = '';
    }
    if (event.name === 'nodeDragging') {
      let dragElementIcon: NodeListOf<HTMLElement> =
        document.querySelectorAll('.e-drag-item.treeview-external-drag .e-icon-expandable');
      for (let i: number = 0; i < dragElementIcon?.length; i++) {
        dragElementIcon[i].style.display = 'none';
      }
    }
  }
  ClearFilter() {
    let date = new Date();
    this.calendarDate = this.datepipe.transform(date, "MM/dd/yyyy");
    this.global.startTime = this.timefrom=this.datepipe.transform(date,"yyyy-MM-dd HH:mm:ss"); 
    this.timeFromChange();
    this.getEmployee();
    this.pageSize=100;
    this.updatePagination('PagePerItem',1)
  }
  setWorkHours() {
    this.isTimeChange = false;
    this.global.startTime = this.timefrom;
    this.endHour = "23:30";
    this.getCalendarScheduledLists();
  }

  //////////////////////////// Apply calendarschedule list///////////////////////
  ApplyFilter() {
    this.getEmployee();
    this.getCalendarScheduledLists();
  }
  ///////////////////// Get Calendar Schedule List////////////////////////////////////
  getCalendarScheduledLists() {
    this.getEvent.consultantId = this.EmployeeId ? this.EmployeeId : "00000000-0000-0000-0000-000000000000";
    this.getEvent.startDate = this.global.getDateTimeString(this.calendarDate);
    let url = "api/Event/GetEventListforCalender";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.getEvent, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.scheduledList = [];

        for (let i = 0; i < data?.length; i++) {
          let newObj: { [key: string]: Object } = {};
          newObj.Name = data[i].clientName;
          newObj.startDate = data[i].appointmentDate;
          newObj.startTime = new Date(data[i].startTime);
          newObj.endTime = new Date(data[i].endTime);
          newObj.appointmentId = data[i].id;
          newObj.EmployeeID = data[i].consultantId;
          newObj.bgColor = "#ff6600"
          newObj.color = "#ffffff";
          newObj.clientId = data[i].clientId;
          newObj.getConfirmation = data[i].getConfirmation;
          newObj.clientConfirmation = data[i].clientConfirmation;
          // newObj.isVisitCancelled = data[i].isVisitCancelled;
          // newObj.isVisitstarted = data[i].isVisitstarted;
          // newObj.isVisitMissed = data[i].isVisitMissed;
          // newObj.scheduleStatusLid = (data[i].isVisitstarted == false &&
          //   data[i].isVisitMissed == false && data[i].isVisitCancelled == false) ? "Not yet started" : data[i].isVisitstarted == true ? "Started" : (data[i].isVisitCancelled == true) ? "Cancelled" :"Missed";

          this.scheduledList.push(newObj);
        }
        console.log("Scheduled List:", this.scheduledList);
        if (this.scheduleObj) {
          this.scheduleObj.eventSettings = {
            dataSource: this.scheduledList,
            enableTooltip: true,
            fields: {
              subject: { title: "Client Name", name: "Name" },
              startTime: { title: "Start Time", name: "startTime" },
              endTime: { title: "End Time", name: "endTime" },
            },
          };

          this.scheduleObj.refresh(); // Force update
        }
      });
  }
  // ................................................getCustomFrequency...................................................
  getCustomFrequency() {
    let urlstatus = "api/LOV/getLovDropDown?"
    let paramsstatus = new URLSearchParams();
    paramsstatus.append("ListCode", "CUSTOMFREQUENCY");
    this.CommonAPI.getDropDownList("CUSTOMFREQUENCY", paramsstatus, urlstatus, "LovDropDown").then((data: any) => {
      this.CustomFrequencyList = data;
      this.customFrequencyLid = this.CustomFrequencyList.filter(st => st.Value == "DAILY")[0]?.Key
    });
  }
  ////...............................Get schedule data from click event...............////
  editDataPopup(args, editData: TemplateRef<any>): void {
    let data: any = args;
  //single event click//
  console.log(args, editData,"..........................")
  if (data.type == "QuickInfo") {
    data.cancel = true; //.......tooltip cancel........//
    this.oldscheduleEmployeeId = args.data.EmployeeID;
    this.scheduleEditList.EmployeeID=args.data.EmployeeID;
    this.scheduleEditList.startDate = this.datepipe.transform(
      args.data.startTime,
      "MM/dd/yyyy"
    );
    this.scheduleEditList.startTime =
    args.data.startTime != null
        ? this.datepipe.transform(args.data.startTime, "yyyy-MM-dd HH:mm:ss")
        : null;
    this.scheduleEditList.endTime =
    args.data.endTime != null
        ? this.datepipe.transform(args.data.endTime, "yyyy-MM-dd HH:mm:ss")
        : null;
    this.scheduleEditList.clientId = args.data.clientId;
    this.scheduleEditList.appointmentId = args.data.appointmentId;      
    this.clientConfirmation = args.data.clientConfirmation;
    this.StartDate = args.data.startTime;
    this.EndDate = args.data.endTime;
    setTimeout(() => {     
      this.getConfirmation = args.data.getConfirmation;
    }, 1000);
      console.log(args.data)
      if(args.data?.Name!=null&&args.data?.Name!=undefined&&args.data?.Name!=''){
            document.getElementById("openEditor").click();
      }
      else{
        data.cancel = true;
      }
  }
  //overlaping eventsclick//
  else if (data.type == "EventContainer") {
    data.cancel = false;
  }
  else {
    data.cancel = true;
  }
} 
  /////////////////////////////// Get scheduledata from After Drop&Drag Event////////////////////////////////////////////
  onActionBegin(event: any): void {
    if(event.data!=undefined&&event.data!=null&&event.data!=''){
      this.scheduleEditList.EmployeeID = event.data.EmployeeID;      
    }
  }
  ///////////////////////////// Get scheduledata from Before Drop&Drag Event/////////////////////////
  onDragStart(args): void {
    console.log(args)
    this.oldscheduleEmployeeId = args.data.EmployeeID;
    this.scheduleEditList.startDate = this.datepipe.transform(
      args.data.startDate,
      "MM/dd/yyyy"
    );    this.scheduleEditList.startTime =
      args.data.startTime != null
          ? this.datepipe.transform(args.data.startTime, "yyyy-MM-dd HH:mm:ss")
          : null;
      this.scheduleEditList.endTime =
      args.data.endTime != null
          ? this.datepipe.transform(args.data.endTime, "yyyy-MM-dd HH:mm:ss")
          : null;
    this.scheduleEditList.visitScheduleId = args.data.visitScheduleId;
    this.scheduleEditList.appointmentId = args.data.appointmentId;
    this.scheduleEditList.clientId = args.data.clientId;
    args.interval = 1
  }
  onDragStop(args){
    console.log(args);
    // this.oldscheduleEmployeeId = args.data.EmployeeID;
    this.scheduleEditList.EmployeeID=args.data.EmployeeID;
    // this.scheduleEditList.startDate = this.datepipe.transform(
    //   args.data.startTime,
    //   "MM/dd/yyyy"
    // );
    // this.scheduleEditList.startTime =
    // args.data.startTime != null
    //     ? this.datepipe.transform(args.data.startTime, "yyyy-MM-dd HH:mm:ss")
    //     : null;
    // this.scheduleEditList.endTime =
    // args.data.endTime != null
    //     ? this.datepipe.transform(args.data.endTime, "yyyy-MM-dd HH:mm:ss")
    //     : null;
    this.scheduleEditList.appointmentId = args.data.appointmentId;
    if(this.oldscheduleEmployeeId != args.data.EmployeeID)
    this.updateCalendarScheduleEmployee('dragevent');
  }

OutBoundCall(){
  const currentDateTime = new Date();
  const EventStartdate = new Date(this.scheduleEditList.startTime);
  const EventEnddate = new Date(this.scheduleEditList.endTime);
  console.log(this.StartDate,EventStartdate);
  // Extract business hours (only hr & min)
  const businessStartTime = new Date(this.global.businessStartTime);
  const businessEndTime = new Date(this.global.businessEndTime);
  const startHour = businessStartTime.getHours();
  const startMin = businessStartTime.getMinutes();
  const endHour = businessEndTime.getHours();
  const endMin = businessEndTime.getMinutes();

  // Build today/tomorrow markers
  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);

  // Build today's business window
  const businessStartToday = new Date(today);
  businessStartToday.setHours(startHour, startMin, 0, 0);

  const businessEndToday = new Date(today);
  if (endHour < startHour)
    businessEndToday.setDate(businessEndToday.getDate() + 1);
  businessEndToday.setHours(endHour, endMin, 0, 0);

  // Build next‐day business start
  const nextDayBusinessStart = new Date(tomorrow);
  nextDayBusinessStart.setHours(startHour, startMin, 0, 0);

  const fifteenMinutes = 15 * 60 * 1000;
  const eventTime = EventStartdate.getTime();
  const currentTime = currentDateTime.getTime();

  const isToday = EventStartdate.toDateString() === today.toDateString();
  const isTomorrow =
    EventStartdate.toDateString() === tomorrow.toDateString();
console.log( this.getConfirmation ,this.global.isValidCcxAccessKey , this.clientConfirmation ,   (isToday || isTomorrow) ,eventTime > currentTime +fifteenMinutes)
  if (
    this.getConfirmation &&
    this.global.isValidCcxAccessKey &&
    this.clientConfirmation &&
    (isToday || isTomorrow)
  ) {
      if( isToday && eventTime < currentTime)
      {
          this.msg = "the event time is passed ";
           document.getElementById("openNoCallModel")?.click();
      }
      else if( isToday && eventTime <= currentTime +fifteenMinutes)
        {
           this.msg = "short notice";
           document.getElementById("openNoCallModel")?.click();
        }
     else if (isToday && eventTime < businessStartToday.getTime()+fifteenMinutes) {
        this.msg = "it is outside of business hours"
        document.getElementById("openNoCallModel")?.click();
      }
       else if (
      isToday &&
      currentTime < businessEndToday.getTime() - fifteenMinutes &&
      eventTime > businessStartToday.getTime() + fifteenMinutes
    ) {
       this.updatecalendarschedule.getConfirmation = true;
      document.getElementById("opencallModel")?.click();     
      // 2nd: Today but after business end, before next day's start+15
    } else if (
      (isToday || isTomorrow ) &&
      currentTime > businessEndToday.getTime() - fifteenMinutes &&
      eventTime < nextDayBusinessStart.getTime() + fifteenMinutes
    ) {
       this.msg = "it is outside of business hours"
      document.getElementById("openNoCallModel")?.click();

      // 3rd: Event is beyond next day's start +15 → allow call
    } 
     else if (eventTime > nextDayBusinessStart.getTime() + fifteenMinutes) {
      this.updatecalendarschedule.getConfirmation = true;
      this.updateCalendarScheduleEmployee('clickevent');
    }
     else {
      this.updatecalendarschedule.getConfirmation = true;
      this.updateCalendarScheduleEmployee('clickevent');
     }
  } 
  else {
     if(this.getConfirmation == false)
        this.updatecalendarschedule.getConfirmation = false;
      else
      this.updatecalendarschedule.getConfirmation = true;
    this.updateCalendarScheduleEmployee('clickevent');
      }

}
SaveCallEvent() {
  this.updatecalendarschedule.getConfirmation = true;
  this.updateCalendarScheduleEmployee('clickevent');
  document.getElementById("opencallModel")?.click();
}
  //////////////////////////////Assign CalendarScheddule to Another Emp/////////////////////////////////////////
  updateCalendarScheduleEmployee(type) {
    if (this.scheduleEditList?.startTime && this.scheduleEditList?.EndDate) {
      const start = new Date(this.scheduleEditList?.startTime);
      const end = new Date(this.scheduleEditList?.endTime);
      if (start?.toDateString() !== end?.toDateString()) {
        this.toastrService.error("Start and End date must be on the same day.");
        return;
      }
    }
    if(type == 'dragevent')
    {
      this.updatecalendarschedule.eventId = this.scheduleEditList.appointmentId;
      this.updatecalendarschedule.consultantId = this.scheduleEditList.EmployeeID != null ? this.scheduleEditList.EmployeeID : null;
      //  this.updatecalendarschedule.eventDate = this.global.getDateTimeString(this.scheduleEditList.startDate);
       this.updatecalendarschedule.startTime = this.global.getDateTimeString(this.scheduleEditList.startTime);
       this.updatecalendarschedule.endTime = this.global.getDateTimeString(this.scheduleEditList.endTime);
       this.updatecalendarschedule.clientId = this.scheduleEditList.clientId
      this.isClickButton = true;
    }
    if(type == 'clickevent'){
      this.updatecalendarschedule.eventId = this.scheduleEditList.appointmentId;
      this.updatecalendarschedule.consultantId = this.scheduleEditList.EmployeeID != null ? this.scheduleEditList.EmployeeID : null;
      //  this.updatecalendarschedule.eventDate = this.global.getDateTimeString(this.scheduleEditList.startDate);
       this.updatecalendarschedule.startTime = this.global.getDateTimeString(this.scheduleEditList.startTime);
       this.updatecalendarschedule.endTime = this.global.getDateTimeString(this.scheduleEditList.endTime);
       this.updatecalendarschedule.clientId = this.scheduleEditList.clientId
       console.log(this.scheduleEditList);
    }
      let url = "api/Event/UpdateCalenderEvent";
      this.CommonAPI.saveorUpdateFunctionwithResponseTypeText(this.updatecalendarschedule, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any = []) => {
        this.toastrService.success('Schedule updated successfully!');
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
        if (type == 'clickevent') {
          document.getElementById('openEditor').click();
        }
        this.isClickButton = false;
        this.scheduledList = [];
        this.scheduleObj.eventSettings.dataSource = [];
        this.getEmployee();
        this.getCalendarScheduledLists();
      },
        (err: any) => {
          this.saveErr = err
          this.isClickButton = false;
          if (type == 'dragevent') {
            this.toastrService.error(err);
          }
          if (this.saveErr != "") {
            setTimeout(function () {
              this.saveErr = "";
            }.bind(this), 8000);
          }
          this.scheduledList = [];
          this.scheduleObj.eventSettings.dataSource = [];
          this.getEmployee();
          this.getCalendarScheduledLists();
        });
    
  }

  /////////////////////// Getemployee //////////////////////////////////
  getEmployee() {
    this.global.startTime = this.timefrom;
    
    let url = "api/Event/GetEventUserDropDown?";
    this.http.get(url).pipe().subscribe((data : any) =>{
      let matchedData = data.filter((item: any) => item.Key === this.EmployeeId);
      if(matchedData.length ==0)
        matchedData = data;
      this.events = matchedData;
      this.totalEmployees = matchedData.length;
      this.updatePagination('PagePerItem','');
    })
  }
  //////////////////////// Pagination /////////////////////////////////
  updatePagination(type,event) {
    let pageSize= parseInt(this.pageSize?.toString());
    this.scheduleObj.refresh();
    if (type=='PagePerItem') {
      if(event!=null&&event!=undefined&&event!=''){
        this.currentPage = 1;
      }
      this.totalPages = Math.ceil(this.totalEmployees / pageSize);
    }
    const startIndex = (this.currentPage - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    this.paginatedEmployees = this.events.slice(startIndex, endIndex); 
    setTimeout(() => {
      this.stoppagination=false;

    }, 1000);
  }  
  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
    }
    this.stoppagination=true
    this.updatePagination('CurentPage','');  
  }
  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
    this.stoppagination=true
    this.updatePagination('CurentPage','');  
  }
  timeFromChange() {
    let time = this.datepipe.transform(new Date(), "HH:mm");
    let hours = this.timefrom.split(":")[0];
    let minu = this.timefrom.split(":")[1];
    let minu1 = +minu;
    if (minu1 < 30) {
      time = hours + ":00";
    } else {
      time = hours + ":30";
    }
    this.global.startTime = this.global.timefrom = this.timefrom = time;
  }
  datafromEvents(event){
    this.isEvents=event;
    this.ApplyFilter();
  }
  StartDateChange(){
    this.getConfirmation = true;
  }
  
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
}

